export default __webpack_public_path__ + "flagBG.2cd1646dfd6a63faf1bec79f13bc8487.png";